import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function LanguageSelector({ variant = 'default' }) {
  const { language, setLanguage, t } = useLanguage();

  const languages = [
    { code: 'zh', name: '中文', short: 'CN' },
    { code: 'ja', name: '日本語', short: 'JP' },
    { code: 'en', name: 'English', short: 'EN' },
    { code: 'es', name: 'Español', short: 'ES' },
  ];

  if (variant === 'large') {
    // Large variant for login/register pages
    return (
      <div className="auth-language-switch" aria-label={t('selectLanguage')}>
        <div className="auth-language-switch-track">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => setLanguage(lang.code)}
              className={`auth-language-switch-button ${
                language === lang.code
                  ? 'is-active'
                  : ''
              }`}
            >
              {lang.short}
            </button>
          ))}
        </div>
      </div>
    );
  }

  // Default compact variant for headers
  return (
    <div className="relative inline-block">
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="rounded-xl border border-border-subtle bg-card px-4 py-2 text-sm font-semibold text-foreground shadow-sm outline-none transition hover:bg-secondary focus-visible:ring-2 focus-visible:ring-ring"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}
